// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2e7pY","select":"Header_select__2C8kV","clinic":"Header_clinic__19KXw"};